import { render, staticRenderFns } from "./course-repair-information.vue?vue&type=template&id=46be7bbc&scoped=true&"
import script from "./course-repair-information.vue?vue&type=script&lang=js&"
export * from "./course-repair-information.vue?vue&type=script&lang=js&"
import style0 from "./course-repair-information.vue?vue&type=style&index=0&id=46be7bbc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46be7bbc",
  null
  
)

export default component.exports